var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.riskLevelList, function(risk) {
      return _c(
        "div",
        {
          staticClass: "content-row content-row-column risk-box",
          on: {
            click: function($event) {
              _vm.setModalInfo(risk)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass:
                "content-row content-align-center content-row-between",
              staticStyle: { "padding-left": ".3rem", "padding-right": ".5rem" }
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    width: "4rem",
                    height: "4rem",
                    "border-radius": ".5rem",
                    overflow: "hidden"
                  }
                },
                [
                  _c("canvas", {
                    staticClass: "risk-body",
                    attrs: { "data-key": risk.key, "data-detail": risk.detail }
                  })
                ]
              ),
              _vm._v(" "),
              _c("img", {
                staticStyle: {
                  "margin-left": ".1rem",
                  width: "4rem",
                  height: "4rem",
                  "border-radius": ".5rem"
                },
                attrs: { src: _vm.getRiskImg(risk) }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "content-row content-row-column auto-width" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "content-row content-row-between content-align-center",
                      staticStyle: {
                        "margin-left": ".2rem",
                        "margin-bottom": ".2rem"
                      }
                    },
                    [
                      _c("span", { staticClass: "font-16" }, [
                        _vm._v(_vm._s(risk.name))
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "font-14",
                          staticStyle: { color: "#8d8d8d" }
                        },
                        [_vm._v(_vm._s(risk.detail))]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "level-box font-12",
                          class: {
                            "level-severe": _vm.hClass,
                            "level-mild": _vm.mClass,
                            "level-normal": _vm.nClass
                          }
                        },
                        [_vm._v(_vm._s(_vm.tips.tip))]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "content-row content-align-end",
                      staticStyle: { width: "9rem", height: "1.5rem" }
                    },
                    [
                      _c("canvas", {
                        staticClass: "risk-bar",
                        attrs: {
                          "data-value": risk.value,
                          "data-level": risk.level
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "content-row content-row-between font-12",
                      staticStyle: { width: "9rem", padding: "0 .5rem" }
                    },
                    [
                      _c("span", [_vm._v(_vm._s(_vm.$tc("levelName", 2)))]),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.$tc("levelName", 1)))]),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.$tc("levelName", 0)))])
                    ]
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "content-row",
              staticStyle: {
                "margin-top": ".8rem",
                "padding-right": ".3rem",
                "padding-left": ".3rem"
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "content-row font-12",
                  staticStyle: { color: "#949494", "flex-wrap": "wrap" }
                },
                _vm._l(risk.risks, function(key) {
                  return _c("span", { staticClass: "key-box" }, [
                    _vm._v(_vm._s(key.name))
                  ])
                }),
                0
              ),
              _vm._v(" "),
              _vm._m(0, true)
            ]
          )
        ]
      )
    }),
    0
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "content-row-end content-align-end",
        staticStyle: {
          height: "1rem",
          "margin-bottom": ".8rem",
          width: "4rem",
          "padding-left": "3.5rem"
        }
      },
      [_c("div", { staticClass: "down-arrow" })]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2d249289", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d249289","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Symp_item.vue
// module id = null
// module chunks = 